import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { Card, Container, Grid, Row, Col, Button, Typography } from '@sm/wds-react';

import { IconArrowLeft } from '@sm/wds-icons';

import { sendMessage } from '../NewSurvey/helper';

import { CreateWizardConfigContext } from '../../CreateWizardConfigContext';

import './templates.scss';

const Templates = () => {
  const { createWizardConfig, setCreateWizardConfig } = useContext(CreateWizardConfigContext);
  const { templatesList, style, redirectToEditorPage, parentDomain } = createWizardConfig;
  const [shouldRedirectBackToHome, setShouldRedirectBackToHome] = useState(false);
  const [showCreatePollCard, setShowCreatePollCard] = useState(createWizardConfig.showCreatePollCard);

  const { badgeColor, secondaryButtonTextColor, badgeTextTransform, containerBackgroundColor } = style;

  useEffect(() => {
    setShowCreatePollCard(createWizardConfig.showCreatePollCard);
  }, [createWizardConfig]);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--customBadgeColor', badgeColor);
    root.style.setProperty('--customSecondaryTextColor', secondaryButtonTextColor);
    root.style.setProperty('--customBadgeTextTransform', badgeTextTransform);
    root.style.setProperty('--customContainerBackgroundColor', containerBackgroundColor);
  }, [badgeColor, secondaryButtonTextColor, badgeTextTransform, containerBackgroundColor]);

  const handleBackToHome = actionType => {
    if (redirectToEditorPage) {
      const dataToSend = {
        action: actionType,
      };
      sendMessage(`${JSON.stringify(dataToSend)}`, parentDomain);
      setShouldRedirectBackToHome(true);
      setCreateWizardConfig({
        ...createWizardConfig,
        redirectTo: '',
        redirectToEditorPage: false,
        readOnlySurvey: false,
        survey: {},
      });
    } else {
      setShouldRedirectBackToHome(true);
    }
  };

  const handleTemplateSelect = template => {
    const dataToSend = {
      action: 'template_selected',
      details: template,
    };
    sendMessage(`${JSON.stringify(dataToSend)}`, parentDomain);
  };

  const onMessageReceivedFromIframe = useCallback(
    event => {
      if (
        event.data &&
        event.data.message &&
        typeof event.data.message !== 'object' &&
        event.data.source === 'create-wizard-app'
      ) {
        const data = JSON.parse(event.data.message);
        setCreateWizardConfig(data);
        setShouldRedirectBackToHome(true);
      }
    },
    [setCreateWizardConfig]
  );

  useEffect(() => {
    window.addEventListener('message', onMessageReceivedFromIframe);
    return () => window.removeEventListener('message', onMessageReceivedFromIframe);
  }, [onMessageReceivedFromIframe]);

  return (
    <>
      <div className="sm-templates__top">
        <If condition={shouldRedirectBackToHome}>
          <Redirect to="/createwizard" />
        </If>
        <Container mt={3} ml={4}>
          <Button
            data-testid="Templates__BackButton"
            className="sm-templates__back-button"
            size="sm"
            variant="text"
            onClick={() => handleBackToHome('back')}
          >
            <IconArrowLeft />
            Back
          </Button>
        </Container>
        <Container pl={4}>
          <Typography variant="cardTitle">Start from template</Typography>
        </Container>
      </div>

      <Container data-testid="Templates" className="sm-templates">
        <Grid noBleeds>
          <Row className="sm-templates__middle" mt={4}>
            <Col>
              {templatesList &&
                templatesList.map(template => {
                  return (
                    <Card
                      data-testid="Templates__List"
                      key={template.id}
                      onClick={() => handleTemplateSelect(template)}
                      className="sm-templates__cards"
                    >
                      <If condition={showCreatePollCard}>
                        <Container className="sm-templates__title" component="span" px={2} mb={2}>
                          {template.type}
                        </Container>
                      </If>
                      <Container className="sm-templates__subtitle">{template.title}</Container>
                    </Card>
                  );
                })}
            </Col>
          </Row>
        </Grid>
      </Container>
    </>
  );
};

export default Templates;
